<page-load-header *ngIf="!initialized"></page-load-header>

<h4>Submit Conference Expenses</h4>
<div *ngIf="initialized">
  <div *ngIf="!conferences || conferences.length ==0" class="row no-gutters no-candidates" style="min-height: 200px">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Conferences</h4>
      <p>You you are not speaking at any conferences that are using the expense payout feature.</p>
    </div>
  </div>
  <div class="card mb-5" *ngFor="let conference of conferences">
    <div class="card-body p-4">
      <div class="media d-block d-sm-flex">
        <div class="media-body">
          <div class="media mb-2">
            <div class="media-body">
              <div class="row">
                <div class="col-md-10">
                  <h1 class="h5 mb-1">
                    <a [routerLink]="[conference.id]">{{ conference.name }}</a>
                  </h1>

                  <div class="d-md-flex align-items-md-center">
                    <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h2 class="small text-secondary mb-0">Date</h2>
                      <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
                      <span *ngIf="(conference.startDate | date: 'shortDate') != (conference.endDate | date: 'shortDate')" class="align-middle">{{ conference.startDate | date: 'shortDate' }} - {{ conference.endDate | date: 'shortDate' }}</span>
                      <span *ngIf="(conference.startDate | date: 'shortDate') == (conference.endDate | date: 'shortDate')" class="align-middle">{{ conference.startDate | date: 'shortDate' }} </span>
                    </div>
                    <div *ngIf="conference.city && conference.state" class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h4 class="small text-secondary mb-0">Location</h4>
                      <span class="align-middle">{{ conference.city + ', ' + conference.state }}</span>
                    </div>

                  </div>
                </div>
                <div class="col-md-2">
                  <div class="text-right">
                    <div class="position-relative d-inline-block text-right">
                        <a role="button" class="btn btn-xs btn-primary"  id="dropdownMenuButton" [routerLink]="[conference.id]" >Manage Expenses</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
